// Tax Getters

export const getTaxList = state => {
  return state.taxList
}

export const getTaxInfo = state => {
  return state.taxInfo
}

export const getIncome = state => {
  return state.income
}
